var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXHeader = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 27,
  height: 27,
  viewBox: "0 0 27 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.1688 1.16895L1.16882 25.1689L25.1688 1.16895ZM1.16884 1.16895L25.1688 25.1689L1.16884 1.16895Z",
  fill: "#4A148C"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.1688 1.16895L1.16882 25.1689M1.16884 1.16895L25.1688 25.1689",
  stroke: "#4A148C",
  strokeWidth: 2.33766,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgXHeader;